// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"867":"781db3a2","963":"e67ee0d3"}[chunkId] + ".chunk.js";
};